import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import SidebarMenu from "./component/SidebarMenu";
import UserLogin from "./screens/UserLogin";
import UserForgetPassword from "./screens/UserForgetPassword";
import ResetPassword from "./screens/ResetPassword";
import VisitorInformation from "./screens/VisitorInformation";
import VisitorList from "./screens/VisitorList";
import ClientInformation from "./screens/ClientInformation";
import ClientList from "./screens/ClientList";
import VisitorAdd from "./component/VisitorAdd";
import FileUploadComponent from "./component/FileUploadComponent";
import FilterData from "./screens/FilterData";
import RegisterComponent from "./component/RegisterComponent";
import ViewRegisterComponent from "./component/ViewRegisterComponent";
import DemoTest from "./component/DemoTest";
import Demo from "./screens/Demo";
import PasscodePopup from "./component/PasscodePopup"; // Import PasscodePopup

function Navigation() {
  const queryClient = new QueryClient();
  const login = sessionStorage.getItem("login");
  const userdata = sessionStorage.getItem("userdata");

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        {/* Always render PasscodePopup here */}
        <PasscodePopup />

        {login ? (
          userdata === "superAdmin" ? (
            <div className="d-flex justify-content-between" style={{ width: "100%" }}>
              <div style={{ width: "15%", marginRight: "0px" }}>
                <SidebarMenu />
              </div>
              <div style={{ width: "83%" }}>
                <Routes>
                  {/* Super Admin Routes */}
                  <Route path="/" element={<VisitorList />} />
                  <Route path="/demo" element={<DemoTest />} />
                  <Route path="/visitorEntry" element={<VisitorInformation />} />
                  <Route path="/clientEntry" element={<ClientInformation />} />
                  <Route path="/clientList" element={<ClientList />} />
                  <Route path="/visitorAdd" element={<VisitorAdd />} />
                  <Route path="/fileUpload" element={<FileUploadComponent />} />
                  <Route path="/filterData" element={<FilterData />} />
                  <Route path="/demo" element={<Demo />} />
                  <Route path="/userRegister" element={<RegisterComponent />} />
                  <Route path="/viewRegister" element={<ViewRegisterComponent />} />
                </Routes>
              </div>
            </div>
          ) : (
            <div className="d-flex justify-content-between" style={{ width: "100%" }}>
              <div style={{ width: "15%", marginRight: "0px" }}>
                <SidebarMenu />
              </div>
              <div style={{ width: "83%" }}>
                <Routes>
                  {/* Client/User Routes */}
                  <Route path="/" element={<VisitorList />} />
                  <Route path="/visitorEntry" element={<VisitorInformation />} />
                  <Route path="/clientEntry" element={<ClientInformation />} />
                  <Route path="/clientList" element={<ClientList />} />
                  <Route path="/filterData" element={<FilterData />} />
                </Routes>
              </div>
            </div>
          )
        ) : (
          <Routes>
            {/* Auth Routes */}
            <Route path="/" element={<UserLogin />} />
            <Route path="/forgetPassword" element={<UserForgetPassword />} />
            <Route path="/resetPassword" element={<ResetPassword />} />
          </Routes>
        )}
      </Router>
    </QueryClientProvider>
  );
}

export default Navigation;
